/**
 * Globalny fixer polskich "sierotek"
 * - zamienia spację po jednoliterowych spójnikach na NBSP
 * - działa także na dynamicznie dodawanych treściach (MutationObserver)
 */

export function initPolishOrphansFixer() {
  const NBSP = "\u00A0";
  const letters = ["i", "a", "o", "u", "w", "z"];
  const skipTags = new Set([
    "SCRIPT",
    "STYLE",
    "NOSCRIPT",
    "TEXTAREA",
    "INPUT",
    "CODE",
    "PRE"
  ]);

  const letterGroup = letters.join("");

  function fix(root) {
    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          const parent = node.parentElement;
          if (!parent) return NodeFilter.FILTER_REJECT;
          if (skipTags.has(parent.tagName)) return NodeFilter.FILTER_REJECT;
          if (!node.nodeValue?.trim()) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        }
      }
    );

    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach(node => {
      const original = node.nodeValue;

      const updated = original.replace(
        new RegExp(
          `(^|[\\s\\u00A0])([${letterGroup}])([,.:;!?\\)\\]\\}”’"\\-—])?([\\s]+)`,
          "gi"
        ),
        (_, p1, p2, p3 = "") => `${p1}${p2}${p3}${NBSP}`
      );

      if (original !== updated) {
        node.nodeValue = updated;
      }
    });
  }

  // Pierwsze uruchomienie po starcie aplikacji
  fix(document.body);

  // Obserwator dla dynamicznych treści (React, lazy loading, CMS itp.)
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          fix(node);
        } else if (node.nodeType === Node.TEXT_NODE && node.parentElement) {
          fix(node.parentElement);
        }
      });

      if (mutation.type === "characterData" && mutation.target?.parentElement) {
        fix(mutation.target.parentElement);
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  return observer; // gdybyś kiedyś chciał go odłączyć
}
